module.exports = __webpack_public_path__ + "static/media/become_a_host.f31e7d26.webp";